import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    padding: '2rem',
    backgroundColor: theme.palette.container.background,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },
  label: {
    fontSize: '1.125rem',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  textField: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
}));

export default useStyles;
